import auth from './auth';
import cities from './cities';
import common from './common';
import categories from './categories';
import configuration from './configuration';
import countries from './countries';
import currencies from './currencies';
import customers from './customers';
import dangerousItems from './dangerousItems';
import dashboard from './dashboard';
import faq from './faq';
import faqCategory from './faqCategory';
import invoices from './invoices';
import measurementUnits from './measurementUnits';
import notifications from './notifications';
import orders from './orders';
import paymentGateways from './paymentGateways';
import paymentMethods from './paymentMethods';
import roles from './roles';
import settings from './settings';
import shipforme from './shipforme';
import shippingCompanies from './shippingCompanies';
import userAddresses from './userAddresses';
import users from './users';
import vouchers from './vouchers';
import contactRequests from './contactRequests';

export default {
  auth,
  cities,
  common,
  categories,
  configuration,
  countries,
  currencies,
  customers,
  dangerousItems,
  dashboard,
  faq,
  faqCategory,
  invoices,
  measurementUnits,
  notifications,
  orders,
  paymentGateways,
  paymentMethods,
  roles,
  settings,
  shipforme,
  shippingCompanies,
  userAddresses,
  users,
  vouchers,
  contactRequests
};
